require('../es');
require('../web');
var path = require('../internals/path');

module.exports = path;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/stable/index.js
// module id = 945
// module chunks = 3